import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-container">
      <p>Made by</p>
      <p>n4m1t</p>
    </footer>
  );
};

export default Footer;
